import React from "react";
import {Button, Tooltip} from "antd";
import "./TooltipButton.css"

function TooltipButton(props) {
    return (<Tooltip title={props.title}>
        <Button disabled={props.disabled} type={!props.useButtonInsteadOfIcon && "circle"} icon={props.icon} className={`action-btn ${props.className}`} size={!props.useButtonInsteadOfIcon && props.size} style={props.style} onClick={props.onClick}>
            {props.useButtonInsteadOfIcon && props.title}
        </Button>
    </Tooltip>)
}

export default TooltipButton;